<template>
  <div class="role-page d-flex">
    <aside class="side-nav">
      <h4 class="mb-3 side-nav-title">学员中心</h4>
      <button type="button" class="nav-btn" @click="goHome">首页</button>
      <button type="button" class="nav-btn" @click="goExamTab">在线考试</button>
      <button type="button" class="nav-btn" @click="goScoreTab">成绩查询</button>
      <button type="button" class="nav-btn active">更多讯息</button>
      <button type="button" class="btn btn-success mt-auto w-100" @click="logout">退出登录</button>
    </aside>

    <main class="content-area">
      <section class="card-box exam-entry-strong">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h4 class="mb-0"><span class="more-info-title-em">更多讯息</span></h4>
        </div>
        <div class="small mb-2 more-info-lead">考试相关说明与常用提示。</div>
        <div class="result-shell more-info-result">
          <div class="more-info-grid">
            <article class="more-info-panel">
              <h5 class="more-info-panel-title">联系与求助</h5>
              <div class="more-info-body">
                如果您在登录、考前核验、进入考试或作答过程中遇到问题，请联系<strong>监考教师</strong>；<strong>或者添加协会微信：15602875802</strong>
              </div>
            </article>
            <article class="more-info-panel">
              <h5 class="more-info-panel-title">考试纪律与诚信</h5>
              <ul class="more-info-list mb-0">
                <li>请独立完成作答，禁止抄袭、替考及使用未经允许的通讯工具。</li>
                <li>考试期间请按要求保持摄像头与麦克风状态，勿恶意遮挡或退出全屏，以免被记录为异常行为。</li>
                <li>交卷前请确认答案已保存；提交后请服从监考安排，勿擅自传播试题内容。</li>
              </ul>
            </article>
            <article class="more-info-panel more-info-panel--full">
              <h5 class="more-info-panel-title">环境与使用建议</h5>
              <ul class="more-info-list mb-0">
                <li>建议使用最新版 <strong>Chrome</strong> 或 <strong>Edge</strong> 浏览器，并尽量使用有线网络或稳定 Wi‑Fi。</li>
                <li>开考前请检查设备电量、摄像头与麦克风权限；尽量关闭无关软件减少弹窗干扰。</li>
                <li>成绩公布与否由管理员设置，交卷后可在「成绩查询」中查看已公开的考试结果。</li>
              </ul>
            </article>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'StudentMoreInfoView',
  created() {
    const raw = localStorage.getItem('exam_user')
    if (!raw) {
      window.location.hash = '#/'
      return
    }
    try {
      const u = JSON.parse(raw)
      if (String(u.role || '').toLowerCase() !== 'student') {
        window.location.hash = '#/dashboard'
      }
    } catch (e) {
      window.location.hash = '#/'
    }
  },
  methods: {
    goHome() {
      try {
        sessionStorage.removeItem('student_open_tab')
      } catch (e) {
        void e
      }
      window.location.hash = '#/student/home'
    },
    goExamTab() {
      try {
        sessionStorage.setItem('student_open_tab', 'exam')
      } catch (e) {
        void e
      }
      window.location.hash = '#/student/home'
    },
    goScoreTab() {
      try {
        sessionStorage.setItem('student_open_tab', 'score')
      } catch (e) {
        void e
      }
      window.location.hash = '#/student/home'
    },
    logout() {
      localStorage.removeItem('exam_user')
      window.dispatchEvent(new Event('auth-changed'))
      window.location.hash = '#/'
    }
  }
}
</script>

<style scoped>
/* 与 StudentHomeView 学员端：成绩查询 / 在线考试 统一蓝白基调 */
.role-page {
  position: relative;
  min-height: 100vh;
  padding: 20px;
  color: #dce9ff;
  background:
    radial-gradient(circle at 8% 10%, rgba(75, 133, 255, 0.26), transparent 34%),
    radial-gradient(circle at 90% 18%, rgba(52, 190, 255, 0.2), transparent 30%),
    linear-gradient(150deg, #081734, #0c2450 48%, #0a1b3f);
}

.side-nav {
  width: 240px;
  min-height: calc(100vh - 40px);
  margin-right: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: rgba(9, 28, 64, 0.88);
  border: 1px solid rgba(132, 169, 245, 0.38);
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(7, 18, 46, 0.45);
  flex-shrink: 0;
}

.side-nav-title {
  color: #e8f0ff;
  font-weight: 700;
}

.nav-btn {
  border: 1px solid rgba(138, 174, 243, 0.42);
  border-radius: 8px;
  padding: 10px 12px;
  color: #d9e8ff;
  background: rgba(17, 51, 106, 0.74);
  text-align: left;
}

.nav-btn.active {
  background: linear-gradient(120deg, #2f6feb, #5da9ff);
  color: #ffffff;
  border-color: transparent;
}

.content-area {
  flex: 1;
  min-width: 0;
}

.card-box {
  background: rgba(11, 33, 76, 0.8);
  border: 1px solid rgba(138, 174, 243, 0.35);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 14px 32px rgba(7, 18, 46, 0.35);
}

.exam-entry-strong,
.exam-entry-strong .small,
.exam-entry-strong .text-muted {
  color: #1f2a44 !important;
  font-weight: 700 !important;
}

.exam-entry-strong h4 {
  color: #e8f4ff !important;
  font-weight: 700 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* 「更多讯息」：加粗纯黑字，直接叠在深蓝卡片上（无底色、无边框） */
.exam-entry-strong h4 .more-info-title-em {
  color: #000000 !important;
  font-weight: 800 !important;
  background: none !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  display: inline;
  text-shadow: none !important;
}

.more-info-lead {
  color: rgba(220, 233, 255, 0.82) !important;
  font-weight: 500 !important;
  line-height: 1.5;
}

.more-info-result {
  margin-top: 4px;
}

.more-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    'contact rules'
    'tips tips';
  gap: 14px;
  align-items: stretch;
}

.more-info-panel {
  grid-area: auto;
  border: 1px solid #c5d6f5;
  border-radius: 12px;
  padding: 14px 16px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.97), rgba(245, 249, 255, 0.99));
  box-shadow: 0 6px 18px rgba(47, 111, 235, 0.08);
}

.more-info-panel:first-of-type {
  grid-area: contact;
}

.more-info-panel:nth-of-type(2) {
  grid-area: rules;
}

.more-info-panel--full {
  grid-area: tips;
}

.more-info-panel-title {
  font-size: 1rem;
  font-weight: 700;
  color: #1e4b8c;
  margin: 0 0 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #d8e6ff;
}

.more-info-body {
  font-size: 0.9rem;
  line-height: 1.65;
  color: #334155;
  font-weight: 400 !important;
}

.more-info-list {
  margin: 0;
  padding-left: 1.15rem;
  font-size: 0.9rem;
  line-height: 1.65;
  color: #334155;
  font-weight: 400 !important;
}

.more-info-list li {
  margin-bottom: 8px;
  font-weight: 400 !important;
  color: #334155 !important;
}

.more-info-list li:last-child {
  margin-bottom: 0;
}

.more-info-panel strong {
  color: #1e3a5f;
  font-weight: 700;
}

@media (max-width: 992px) {
  .role-page {
    flex-direction: column;
  }

  .side-nav {
    width: 100%;
    min-height: auto;
    margin-right: 0;
    margin-bottom: 12px;
  }

  .more-info-grid {
    grid-template-columns: 1fr;
    grid-template-areas:
      'contact'
      'rules'
      'tips';
  }

  .more-info-panel:first-of-type,
  .more-info-panel:nth-of-type(2),
  .more-info-panel--full {
    grid-area: auto;
  }
}
</style>
